<table>
    <thead>
        <tr>
            <th class="subtable short sortable" (click)="toOrderBy('1')" [appSort]="listaCultivosProductor" data-order="desc" data-name="desProductor">
              {{'mantenimientoCultivos.tabs.cultivos.cultivoProductor.productor' | translate}}
              <div class="sortable-icons">
                <i [ngClass]="getIcon('1')"></i>
              </div>
            </th>
            <th class="subtable short">{{'mantenimientoCultivos.tabs.cultivos.cultivoProductor.licencia' | translate}}</th>
            <th class="subtable action">
                <i class="fas fa-plus" *ngIf="campanyaHabilitada && (this.role === 'Administrador' || this.claims.includes('CUL_PROD_Ins'))"
                  (click)="new=true;editables=''" title="{{'mantenimientoCultivos.tabs.cultivos.cultivoProductor.tituloNew' | translate}}"></i>
            </th>
        </tr>
    </thead>
    <tbody *ngIf="productoresList">
        <app-cultivo-productor-new-edit class="component-in-row" *ngIf="new" [editable]="true" [campanyaHabilitada]="campanyaHabilitada" [cultivoId]="_cultivoId" [paisId]="paisId" [denominacionId]="denominacionId" [productoresList]="productoresList" (close)="new=$event"
        (refresh)="refresh($event)" (editableChanged)="editableChanged($event)" (pushMessage)="pushMessage.emit($event)">
        </app-cultivo-productor-new-edit>
        <app-cultivo-productor-new-edit class="component-in-row" *ngFor="let cultivoProductor of listaCultivosProductor" [campanyaHabilitada]="campanyaHabilitada" [cultivoProductor]="cultivoProductor" [editable]="cultivoProductor === editables" [cultivoId]="_cultivoId" [productoresList]="productoresList"
        (refresh)="refresh($event)" (editableChanged)="editableChanged($event)" (pushMessage)="pushMessage.emit($event)">
        </app-cultivo-productor-new-edit>
    </tbody>
    <tfoot *ngIf="!new && (!listaCultivosProductor|| (listaCultivosProductor && listaCultivosProductor.length < 1))">
        <tr>
          <td colspan="3">
            {{'global.noContent' | translate}}
          </td>
        </tr>
    </tfoot>
</table>
